<template>
  <div class="vacancy-media"
       :class="mediaScrollSelector">
    <OverlayScrollbarsComponent ref="mediaScroll"
                                :options="mediaScrollbarOption"
                                class="vacancy-media__scroll">
      <div class="vacancy-media__inner">

        <div v-if="!gallery || !gallery.length"
             class="vacancy-media__item  _placeholder">
          <div class="vacancy-media__item-inner  _placeholder">

          </div>
        </div>
        <div class="vacancy-media__item"
             v-for="(item, index) in gallery"
             :key="item.id"
             @click.prevent="onImgClick(index)"
        >
          <template v-if="item.type && isVideo(item)">
            <div class="vacancy-media__item-inner">
              <video>
                <source v-if="item.path_web"
                        :type="item.type"
                        :src="item.path_web">
                <source :type="item.type"
                        :src="item.path"
                        :title="createTitleMixin(title, index, true)"
                        :alt="createAltMixin(title, index, true)">
              </video>
            </div>
            <div class="vacancy-media__video-play">
              <img src="../../assets/img/svg/play.svg"
                   alt="play"></div>
          </template>

          <div v-else
               class="vacancy-media__item-inner">
            <picture>
              <source v-if="item.path_web"
                      :srcset="item.path_web"
                      type="image/webp">
              <img :src="item.path"
                   :title="createTitleMixin(title, index)"
                   :alt="createAltMixin(title, index)">
            </picture>
          </div>
          <div v-if="item.title" class="vacancy-media__descr">
            <span class="vacancy-media__descr-ico">
              <BaseSvg name="ico-info"/>
            </span>
            <span class="vacancy-media__descr-content">{{item.title}}</span>
          </div>
        </div>
      </div>
    </OverlayScrollbarsComponent>
  </div>
</template>

<script>
  import {OverlayScrollbarsComponent} from 'overlayscrollbars-vue'
  import {VIDEOS_MIME_TYPES} from '../../constants/files'

  export default {
    name: 'VacancyMedia',
    props: {
      title: String,
      gallery: {
        type: Array,
        required: true
      },
    },
    components: {
      OverlayScrollbarsComponent
    },
    data() {
      return {
        scroll: null
      }
    },
    computed: {
      mediaScrollbarOption() {
        return {
          callbacks: {
            onScroll: this.checkScroll,
            onUpdated: this.checkScroll,
            onHostSizeChanged: this.checkScroll
          }
        }
      },
      mediaScrollSelector() {
        if (!this.scroll) return null

        if (this.scroll.trackLength.y === this.scroll.handleLength.y) {
          return '_scroll-hidden'
        }

        const progress = this.scroll.ratio.y

        if (progress === 0) {
          return '_scroll-start'
        }
        if (progress === 1) {
          return '_scroll-end'
        }

        return null
      }
    },
    methods: {
      checkScroll() {
        const instance = this.$refs.mediaScroll && this.$refs.mediaScroll._osInstace

        if (!instance) {
          return this.progress = null
        }
        this.scroll = instance.scroll()
      },
      isVideo(file) {
        return VIDEOS_MIME_TYPES.includes(file.type)
      },
      onImgClick(index) {
        this.$emit('onShowGallery', index)
      }
    },
    mounted() {
      this.checkScroll()
    }
  }
</script>

<style>

</style>
